var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('span',{staticClass:"p1 r2 fw7",class:[_vm.computedClass, _vm.computedSize]},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }